import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import Restricted from "src/app/Restricted";
import { getSearchPath } from "src/consts/urlPaths";

const PeopleLink = ({ children, item, className }) => (
  <Restricted>
    <Link
      id="people-nav-link"
      to={getSearchPath("people", null, false)}
      aria-label={item.name}
      className={className}
    >
      {children}
    </Link>
  </Restricted>
);
PeopleLink.propTypes = {
  item: PropTypes.object,
  children: PropTypes.node,
  className: PropTypes.string,
};

export default PeopleLink;
